/**
 * LASSO FIX - VERSION CORRIGÉE
 * N'intercepte QUE : Buy It Now + Checkout (PAS Add to Cart)
 */

(function() {
  'use strict';
  
  var LASSO_URL = 'https://checkout.basebdodyworks.com/checkout';
  var DEBUG = true;
  
  function log(msg, data) {
    if (DEBUG) {
      console.log('[🔥 LASSO] ' + msg, data || '');
    }
  }
  
  log('🚀 INTERCEPTION SÉLECTIVE (Buy Now + Checkout seulement)');
  
  // ===== FONCTION DE REDIRECTION =====
  function goToLasso(e, source) {
    if (e) {
      try {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } catch (err) {}
    }
    log('✈️ REDIRECTION: ' + source);
    window.location.href = LASSO_URL;
    return false;
  }
  
  // ===== FONCTION DE VÉRIFICATION =====
  function isAddToCartButton(element, text, name, classes) {
    // Vérifier si c'est un bouton "Add to Cart" (à NE PAS intercepter)
    var addToCartPatterns = [
      'add to cart',
      'add to bag',
      'ajouter au panier',
      'ajouter',
      'add item',
      'add product'
    ];
    
    // Si name="add" -> c'est Add to Cart
    if (name === 'add' || name === 'add-to-cart') {
      return true;
    }
    
    // Si le texte contient "add to"
    for (var i = 0; i < addToCartPatterns.length; i++) {
      if (text.indexOf(addToCartPatterns[i]) > -1) {
        return true;
      }
    }
    
    // Si la classe contient "add-to-cart" ou "add-item"
    if (classes.indexOf('add-to-cart') > -1 || 
        classes.indexOf('add-item') > -1 ||
        classes.indexOf('add-to-bag') > -1) {
      return true;
    }
    
    return false;
  }
  
  // ===== HOOK LASSO SYSTÈME =====
  var lassoCheckInterval = setInterval(function() {
    if (window.LassoCart || window.lasso || window.Lasso) {
      log('🎯 Objet Lasso détecté');
      clearInterval(lassoCheckInterval);
      
      var lassoObj = window.LassoCart || window.lasso || window.Lasso;
      
      if (lassoObj.checkout) {
        lassoObj.checkout = function() {
          log('🚫 Lasso.checkout() intercepté');
          goToLasso(null, 'Lasso.checkout()');
          return false;
        };
      }
      
      if (lassoObj.goToCheckout) {
        lassoObj.goToCheckout = function() {
          log('🚫 Lasso.goToCheckout() intercepté');
          goToLasso(null, 'Lasso.goToCheckout()');
          return false;
        };
      }
    }
  }, 100);
  
  setTimeout(function() {
    clearInterval(lassoCheckInterval);
  }, 10000);
  
  // ===== INTERCEPTION SÉLECTIVE DES CLICS =====
  function handleClick(e) {
    try {
      var target = e.target;
      if (!target) return;
      
      var clickable = target.closest('a, button, input[type="submit"], [role="button"], [data-action], [onclick]');
      if (!clickable) return;
      
      var href = clickable.href || clickable.getAttribute('data-href') || '';
      var text = (clickable.textContent || clickable.value || '').toLowerCase().trim();
      var name = (clickable.name || '').toLowerCase();
      var classes = (clickable.className || '').toLowerCase();
      var id = (clickable.id || '').toLowerCase();
      var dataAction = (clickable.getAttribute('data-action') || '').toLowerCase();
      var onclick = (clickable.getAttribute('onclick') || '').toLowerCase();
      
      // VÉRIFIER SI C'EST "ADD TO CART" (ne PAS intercepter)
      if (isAddToCartButton(clickable, text, name, classes)) {
        // C'est un bouton Add to Cart -> LAISSER PASSER
        if (DEBUG && text.indexOf('add') > -1) {
          log('✅ Add to Cart - Laissé passer: "' + text + '"');
        }
        return; // Ne rien faire, laisser le comportement normal
      }
      
      // Log clics importants (hors Add to Cart)
      if (DEBUG && (
        text.indexOf('buy') > -1 || 
        text.indexOf('checkout') > -1 || 
        text.indexOf('payer') > -1
      )) {
        log('🖱️ Clic:', {
          text: text.substring(0, 40),
          name: name,
          href: href.substring(0, 40)
        });
      }
      
      // ===== 1. BUY IT NOW =====
      var isBuyNow = text.indexOf('buy it now') > -1 || 
                     text.indexOf('acheter maintenant') > -1 ||
                     text.indexOf('buy now') > -1 ||
                     text === 'buy it now' ||
                     name === 'buy' ||
                     name === 'buynow' ||
                     classes.indexOf('buy-it-now') > -1 ||
                     classes.indexOf('buy_now') > -1 ||
                     id.indexOf('buy-it-now') > -1;
      
      if (isBuyNow) {
        log('❌❌❌ BUY IT NOW: "' + text + '"');
        return goToLasso(e, 'BUY IT NOW');
      }
      
      // ===== 2. LIENS CHECKOUT DIRECTS =====
      if (href && (href.indexOf('/checkout') > -1 || href.indexOf('/cart/checkout') > -1)) {
        if (href.indexOf('basebdodyworks.com') === -1 && href.indexOf('lasso') === -1) {
          // Mais pas si c'est un lien "view cart" ou "cart"
          if (href.indexOf('/cart') > -1 && href.indexOf('/checkout') === -1) {
            log('✅ Lien vers panier - Laissé passer');
            return;
          }
          log('❌ Lien checkout: ' + href);
          return goToLasso(e, 'lien checkout');
        }
      }
      
      // ===== 3. FORMULAIRES CHECKOUT (pas /cart/add) =====
      if (clickable.type === 'submit') {
        var form = clickable.closest('form');
        if (form) {
          var action = (form.action || '').toLowerCase();
          
          // Si c'est /cart/add -> laisser passer
          if (action.indexOf('/cart/add') > -1) {
            log('✅ Formulaire Add to Cart - Laissé passer');
            return;
          }
          
          // Si c'est /checkout -> intercepter
          if (action.indexOf('/checkout') > -1) {
            if (action.indexOf('basebdodyworks.com') === -1) {
              log('❌ Formulaire checkout');
              return goToLasso(e, 'formulaire checkout');
            }
          }
        }
      }
      
      // ===== 4. DATA-ACTION CHECKOUT =====
      if (dataAction && dataAction.indexOf('checkout') > -1) {
        log('❌ data-action checkout');
        return goToLasso(e, 'data-action checkout');
      }
      
      // ===== 5. ONCLICK CHECKOUT =====
      if (onclick && onclick.indexOf('checkout') > -1) {
        log('❌ onclick checkout');
        return goToLasso(e, 'onclick checkout');
      }
      
      // ===== 6. BOUTONS CHECKOUT (mot complet "checkout" seulement) =====
      var checkoutWords = [
        'checkout',
        'check out', 
        'go to checkout',
        'proceed to checkout',
        'payer',
        'commander',
        'passer la commande',
        'finalize purchase',
        'complete order'
      ];
      
      for (var i = 0; i < checkoutWords.length; i++) {
        var word = checkoutWords[i];
        if (text === word || text.indexOf(word) > -1) {
          log('❌ Bouton checkout: "' + text + '"');
          return goToLasso(e, 'bouton checkout');
        }
      }
      
      // ===== 7. BOUTONS PRIMAIRES DANS DRAWER =====
      var inDrawer = clickable.closest('.drawer, .cart-drawer, [class*="lasso"]');
      if (inDrawer && clickable.tagName === 'BUTTON') {
        // Seulement si le texte contient explicitement checkout
        if (text.indexOf('checkout') > -1 || text.indexOf('payer') > -1) {
          if (classes.indexOf('btn-primary') > -1 || classes.indexOf('button--primary') > -1) {
            log('❌ Bouton primaire drawer checkout');
            return goToLasso(e, 'drawer checkout button');
          }
        }
      }
      
    } catch (err) {
      log('Erreur handleClick:', err.message);
    }
  }
  
  // Attacher listeners
  document.addEventListener('click', handleClick, true);
  window.addEventListener('click', handleClick, true);
  log('✅ Listeners attachés');
  
  // ===== INTERCEPTION DES SOUMISSIONS DE FORMULAIRE =====
  document.addEventListener('submit', function(e) {
    try {
      var form = e.target;
      if (!form) return;
      
      var action = (form.action || '').toLowerCase();
      
      // Si /cart/add -> laisser passer
      if (action.indexOf('/cart/add') > -1) {
        log('✅ Submit Add to Cart - Laissé passer');
        return;
      }
      
      // Si /checkout -> intercepter
      if (action.indexOf('/checkout') > -1) {
        if (action.indexOf('basebdodyworks.com') === -1) {
          log('❌ Submit checkout');
          return goToLasso(e, 'submit checkout');
        }
      }
      
      // Vérifier le bouton submit
      var submitButton = e.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitButton) {
        var btnText = (submitButton.textContent || submitButton.value || '').toLowerCase();
        var btnName = (submitButton.name || '').toLowerCase();
        
        // Si c'est Add to Cart -> laisser passer
        if (isAddToCartButton(submitButton, btnText, btnName, submitButton.className)) {
          log('✅ Submit via Add to Cart - Laissé passer');
          return;
        }
        
        // Si c'est Buy It Now -> intercepter
        if (btnText.indexOf('buy it now') > -1 || btnText.indexOf('buy now') > -1 || btnName === 'buy') {
          log('❌ Submit Buy It Now');
          return goToLasso(e, 'submit buy now');
        }
      }
      
    } catch (err) {
      log('Erreur submit:', err.message);
    }
  }, true);
  
  log('✅ Listener submit attaché');
  
  // ===== CORRECTION DES BOUTONS BUY IT NOW SEULEMENT =====
  function fixBuyNowButtons() {
    try {
      var allButtons = document.querySelectorAll('button, input[type="submit"]');
      var fixed = 0;
      
      for (var i = 0; i < allButtons.length; i++) {
        var btn = allButtons[i];
        if (btn.hasAttribute('data-lasso-fixed')) continue;
        
        var text = (btn.textContent || btn.value || '').toLowerCase().trim();
        var name = (btn.name || '').toLowerCase();
        var classes = (btn.className || '').toLowerCase();
        
        // IGNORER Add to Cart
        if (isAddToCartButton(btn, text, name, classes)) {
          continue;
        }
        
        // Si c'est Buy It Now
        if (text.indexOf('buy it now') > -1 || 
            text.indexOf('buy now') > -1 ||
            text === 'buy it now' ||
            name === 'buy' ||
            name === 'buynow' ||
            classes.indexOf('buy-it-now') > -1) {
          
          log('🔧 Buy Now button: "' + text + '"');
          btn.addEventListener('click', function(e) {
            log('🔘 Clic Buy Now');
            goToLasso(e, 'buy now direct');
          }, true);
          btn.setAttribute('data-lasso-fixed', 'true');
          fixed++;
        }
      }
      
      if (fixed > 0) {
        log('✅ ' + fixed + ' bouton(s) Buy Now corrigés');
      }
    } catch (err) {
      log('Erreur fixBuyNowButtons:', err.message);
    }
  }
  
  // ===== SURVEILLANCE DU DRAWER =====
  var drawerObserver = null;
  
  function watchLassoDrawer() {
    try {
      var drawer = document.querySelector('.lasso-drawer, .cart-drawer, #cart-drawer, [data-lasso-drawer]');
      
      if (drawer && !drawer.hasAttribute('data-watched')) {
        log('📦 DRAWER trouvé');
        drawer.setAttribute('data-watched', 'true');
        
        drawerObserver = new MutationObserver(function() {
          fixDrawerLinks();
        });
        
        drawerObserver.observe(drawer, {
          childList: true,
          subtree: true
        });
        
        fixDrawerLinks();
      }
    } catch (err) {}
  }
  
  function fixDrawerLinks() {
    try {
      var drawer = document.querySelector('.lasso-drawer, .cart-drawer, #cart-drawer');
      if (!drawer) return;
      
      var elements = drawer.querySelectorAll('a, button');
      var fixed = 0;
      
      for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        if (el.hasAttribute('data-lasso-fixed')) continue;
        
        var href = el.href || '';
        var text = (el.textContent || '').toLowerCase();
        var name = (el.name || '').toLowerCase();
        
        // Ignorer Add to Cart
        if (isAddToCartButton(el, text, name, el.className)) {
          continue;
        }
        
        // Lien checkout
        if (href && href.indexOf('/checkout') > -1 && href.indexOf('basebdodyworks.com') === -1) {
          log('🔧 Lien drawer checkout');
          el.href = LASSO_URL;
          el.setAttribute('data-lasso-fixed', 'true');
          fixed++;
          continue;
        }
        
        // Bouton checkout (pas "view cart")
        if ((text.indexOf('checkout') > -1 || text.indexOf('payer') > -1) && 
            text.indexOf('view') === -1 && 
            text.indexOf('voir') === -1) {
          el.addEventListener('click', function(e) {
            log('🔘 Clic drawer checkout');
            goToLasso(e, 'drawer checkout');
          }, true);
          el.setAttribute('data-lasso-fixed', 'true');
          fixed++;
        }
      }
      
      if (fixed > 0) {
        log('✅ ' + fixed + ' éléments drawer corrigés');
      }
    } catch (err) {}
  }
  
  // ===== OBSERVER GLOBAL =====
  function startGlobalObserver() {
    try {
      var observer = new MutationObserver(function() {
        watchLassoDrawer();
        fixBuyNowButtons();
      });
      
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        log('✅ Observer actif');
      }
    } catch (err) {}
  }
  
  // ===== INTERCEPTION window.location =====
  try {
    var origAssign = window.location.assign;
    window.location.assign = function(url) {
      if (typeof url === 'string' && url.indexOf('/checkout') > -1 && url.indexOf('basebdodyworks.com') === -1) {
        // Sauf si c'est juste /cart
        if (url.indexOf('/cart') > -1 && url.indexOf('/checkout') === -1) {
          return origAssign.call(window.location, url);
        }
        log('🚫 location.assign');
        return origAssign.call(window.location, LASSO_URL);
      }
      return origAssign.call(window.location, url);
    };
  } catch (err) {}
  
  try {
    var origReplace = window.location.replace;
    window.location.replace = function(url) {
      if (typeof url === 'string' && url.indexOf('/checkout') > -1 && url.indexOf('basebdodyworks.com') === -1) {
        if (url.indexOf('/cart') > -1 && url.indexOf('/checkout') === -1) {
          return origReplace.call(window.location, url);
        }
        log('🚫 location.replace');
        return origReplace.call(window.location, LASSO_URL);
      }
      return origReplace.call(window.location, url);
    };
  } catch (err) {}
  
  // ===== INITIALISATION =====
  function init() {
    log('⚡ INIT');
    fixBuyNowButtons();
    watchLassoDrawer();
    startGlobalObserver();
    
    var count = 0;
    var interval = setInterval(function() {
      count++;
      fixBuyNowButtons();
      watchLassoDrawer();
      
      if (count >= 60) {
        clearInterval(interval);
        log('⏱️ Surveillance terminée');
      }
    }, 1000);
  }
  
  init();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }
  
  setTimeout(init, 500);
  setTimeout(init, 1000);
  
  // ===== DIAGNOSTIC =====
  window.diagnoseLasso = function() {
    console.clear();
    console.log('╔════════════════════════════════════╗');
    console.log('║   🔍 DIAGNOSTIC LASSO             ║');
    console.log('╚════════════════════════════════════╝\n');
    
    console.log('🎯 URL Lasso:', LASSO_URL);
    console.log('');
    
    // Tous les boutons
    var allButtons = document.querySelectorAll('button, input[type="submit"]');
    var addToCartButtons = [];
    var buyNowButtons = [];
    var checkoutButtons = [];
    
    for (var i = 0; i < allButtons.length; i++) {
      var btn = allButtons[i];
      var text = (btn.textContent || btn.value || '').toLowerCase().trim();
      var name = (btn.name || '').toLowerCase();
      
      if (isAddToCartButton(btn, text, name, btn.className)) {
        addToCartButtons.push({btn: btn, text: text, name: name});
      } else if (text.indexOf('buy') > -1 || name === 'buy') {
        buyNowButtons.push({btn: btn, text: text, name: name});
      } else if (text.indexOf('checkout') > -1) {
        checkoutButtons.push({btn: btn, text: text});
      }
    }
    
    console.log('🛒 ADD TO CART (laissés passer):', addToCartButtons.length);
    for (var i = 0; i < Math.min(addToCartButtons.length, 3); i++) {
      console.log('  ✅ "' + addToCartButtons[i].text + '" (name: ' + addToCartButtons[i].name + ')');
    }
    
    console.log('\n💰 BUY IT NOW (interceptés):', buyNowButtons.length);
    for (var i = 0; i < buyNowButtons.length; i++) {
      var fixed = buyNowButtons[i].btn.hasAttribute('data-lasso-fixed');
      console.log('  ' + (fixed ? '✅' : '❌') + ' "' + buyNowButtons[i].text + '"');
    }
    
    console.log('\n🔑 CHECKOUT (interceptés):', checkoutButtons.length);
    for (var i = 0; i < checkoutButtons.length; i++) {
      console.log('  ❌ "' + checkoutButtons[i].text + '"');
    }
    
    console.log('\n💡 forceLasso() pour tester');
  };
  
  window.forceLasso = function() {
    goToLasso(null, 'forceLasso()');
  };
  
  log('✅✅✅ SCRIPT SÉLECTIF ACTIF ✅✅✅');
  
})();